// extracted by mini-css-extract-plugin
export default {"variant":"Variant_variant__3t4dL","checkbox-wrapper":"Variant_checkbox-wrapper__g0m8+","checkbox":"Variant_checkbox__UblPi","variant-body":"Variant_variant-body__Feim0"};